import type { MaybeRefOrGetter } from '#imports'
import type { paths, SearchGameConfigurationsRequestBrand } from '../../types/clients/game-configuration'
import { SearchGameConfigurationsRequestSort } from '../../types/clients/game-configuration'
import type { UseQueryOverrideOptions } from '../../types'
import { useOpenapi, useQuery, useCoreConfig, toValue } from '#imports'

/**
 * @title useGameConfigurationClient
 * @see Docs https://game-configuration-prod.spilnu.dk/docs?api-docs.json
 */
export const useGameConfigurationClient = () => {
    const { site } = useCoreConfig()

    const client = useOpenapi<paths>({
        baseUrl: '/gateway/game-configuration',
        service: 'gameConfiguration'
    })

    function getGamesBySlugs(slugs: MaybeRefOrGetter<string[]>, options: UseQueryOverrideOptions = {}) {
        return useQuery(async ({ signal }) => {
            const { data } = await client.POST('/public/game-configurations/search', {
                signal,
                body: {
                    brand: site.brand as unknown as SearchGameConfigurationsRequestBrand,
                    filter: { slugs: toValue(slugs) },
                    sort: SearchGameConfigurationsRequestSort.KEEP_ORDER,
                }
            })

            return data?.data ?? []
        }, {
            ...options,
            key: () => `gameConfiguration:gamesBySlugs-${toValue(slugs).join(',') || 'none'}`,
            enabled: () => toValue(slugs).length > 0 && (options.enabled === undefined || !!toValue(options.enabled)),
        })
    }

    return {
        client,

        getGamesBySlugs
    }
}
